import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { Subscription } from 'rxjs/Subscription';

import { Ad } from '../../enums/ad.enum';
import { Interest } from '../../enums/interest.enum';
import { EnumHelper } from '../../helpers/enum-helper';
import { Application } from '../../models/application';
import { Payment } from '../../models/payment';
import { ApplicationService } from '../../services/application.service';

@Component({
	selector: 'app-review-application',
	templateUrl: './review-application.component.html',
	styleUrls: ['./review-application.component.scss']
})
export class ReviewApplicationComponent implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;

	public application: Observable<Application>;
	public payments: Observable<Payment[]>;

	public enumHelper: typeof EnumHelper = EnumHelper;
	public ads: typeof Ad = Ad;
	public adValues: number[] = Object.values(Ad).filter(e => typeof (e) == "number");
	public interests: typeof Interest = Interest;
	public interestValues: number[] = Object.values(Interest).filter(e => typeof (e) == "number");

	constructor(private applicationService: ApplicationService,
		private route: ActivatedRoute) {
		this.subscriptionManager = new Subscription();
	}

	ngOnInit() {
		this.subscriptionManager.add(this.route
			.params
			.subscribe(next => {
				if (next['key']) {
					this.application = this.applicationService.getApplication(next['key']);

					this.subscriptionManager.add(this.application.subscribe(next => {
						this.payments = this.applicationService.getPayments(next.$key);
					}));
				}
			}));
	}

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/review-application/review-application.component.ts